import React from "react";
import { Handle } from "reactflow";

const CompletionLightNode = ({ data }) => {
  const { isOn } = data;

  return (
    <div
      className="flex flex-col items-center justify-center w-[170px] h-[65px] rounded-md text-slate-100 border-none text-lg relative p-1 bg-gray-600"
    >
      <p
        className={`font-bold ${
          isOn ? "text-red-600" : "text-red-950"
        } bg-black`}
      >
        LEVEL COMPLETE
      </p>

      {/* Target handles for edge connections */}
      <Handle
        type="target"
        id="input-1"
        position="bottom"
        style={{
          background: "#fff",
          borderRadius: "50%",
          width: "10px",
          height: "10px",
          position: "absolute",
          bottom: "0",
        }}
      />
      <Handle
        type="target"
        id="input"
        position="bottom"
        style={{
          background: "#fff",
          borderRadius: "50%",
          width: "10px",
          height: "10px",
          position: "absolute",
          bottom: "0",
        }}
      />
    </div>
  );
};

export default CompletionLightNode;
